(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
jQuery(document).ready(function () {

  function extend(a, b) {
    for (var key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }
    return a;
  }

  toggleNav("nav.navbar", ".hamburger");

  var nav = jQuery("nav.navbar");
  var main = jQuery("#main")
  var navTranslate = 0;
  var mainPosition = jQuery("nav.navbar").width();
  var navPosition = 0;



  function backNav() {
    jQuery(".back").on("click", function () {
    });
  }
  function toggleNav(navClass, hamburgerClass) {

    var html_rtl = jQuery('html').attr('dir');

    jQuery(hamburgerClass).on("click", function () {
      jQuery(navClass).toggleClass("open");

      var windowWidth = jQuery(window).width();

      if (!jQuery(navClass).hasClass('open')) {
        if (windowWidth > 575) {
          if (html_rtl == 'rtl') {
            jQuery(navClass).css("transform", 'translateX(300px)');
          }
          else {
            jQuery(navClass).css("transform", 'translateX(-300px)');
          }
        }
        else {
          if (html_rtl == 'rtl') {
            jQuery(navClass).css("transform", 'translateX(250px)');
          }
          else {
            jQuery(navClass).css("transform", 'translateX(-250px)');
          }
        }
        resetNav();
      } else {
        jQuery(navClass).css("transform", 'translateX(0)');
      }
    })

    jQuery(window).resize(function () {
      var windowWidth = jQuery(window).width();
      // console.log (windowWidth);

      if (windowWidth < 992) {
        if (windowWidth > 575) {
          if (html_rtl == 'rtl') {
            jQuery(navClass).css("transform", 'translateX(300px)');
          }
          else {
            jQuery(navClass).css("transform", 'translateX(-300px)');
          }
        }
        else {
          if (html_rtl == 'rtl') {
            jQuery(navClass).css("transform", 'translateX(250px)');
          }
          else {
            jQuery(navClass).css("transform", 'translateX(-250px)');
          }
        }
        resetNav();
      }
      else {
        jQuery(navClass).css("transform", 'translateX(0)');
      }
    });
  }

  function toggleLevels(nav) {

  }
  function resetNav() {
    mainPosition = jQuery('nav.navbar').width();
    navPosition = 0;
    jQuery(".nav-overlay").removeClass("nav-overlay");
    jQuery(".submenu").removeClass("open");
  };

  function sideMenu(el, main, trigger, options) {
    this.el = el;
    this.main = main;
    this.trigger = trigger;
    this.options = extend(this.defaults, options);
    this._init();
  }

  sideMenu.prototype = {
    defaults: {
      backClass: '.back',
      navLevel: '.nav-level'
    },
    _init: function () {
      var self = this;
      this.level = 1;
      this.menuOpen = false;
      this.navTranslate = 0;
      this.navPosition = 0;
      this.navWidth = jQuery(this.el).width();

      this._openMenu();
      this._toggleLevels();
      this._toggleBack();
      this._setLevels(this.defaults.navLevel);

    },
    _toggleLevels: function () {
      let self = this;

      jQuery(".we-mega-menu-li a[href$='#']").on("click", function (e) {

        e.preventDefault();
        let navLevel = jQuery(this).closest("div.nav-level");

        if (jQuery(this).next().hasClass("submenu")) {

          jQuery(this).next().toggleClass("open");

          navLevel.toggleClass("nav-overlay nav-covered");

          self.navWidth = self.navWidth + self.navTranslate;
          self.navPosition = self.navPosition + self.navTranslate;

          self._transform(self.navWidth, self.main);
          self._transform(self.navPosition, self.el);

        }
      });
    },
    _toggleBack: function () {

      let self = this,
        back = jQuery(self.defaults.backClass);

      back.on("click", function () {
        let navLevel = jQuery(this).closest(self.defaults.navLevel),
          navOverlay = jQuery(this).closest(".nav-overlay.nav-covered");
        navOverlay.toggleClass("nav-overlay nav-covered");

        self.navWidth = self.navWidth - self.navTranslate;
        self.navPosition = self.navPosition - self.navTranslate;

        self._transform(self.navWidth, self.main);
        self._transform(self.navPosition, self.el);

        (navLevel.hasClass('open')) ? navLevel.toggleClass("open") : null;

      });
    },
    _transform: function (value, selector) {
      jQuery(selector).css("transform", 'translate3d(-' + value + 'px,0,0)');
    },
    _openMenu: function () {
      var self = this;
      jQuery(self.trigger).on("click", function () {
        jQuery(self.trigger).toggleClass("is-active");

        if (jQuery(self.trigger).hasClass("is-active")) {
          self.menuOpen = true;
          self._resetMenu();
        } else {
          self.menuOpen = false;
          self.level = 0;
        };
      });
    },
    _resetMenu: function () {

      this.navWidth = jQuery(this.el).width();
      this.navPosition = 0;
      jQuery(".nav-overlay").removeClass("nav-overlay");
      jQuery(".submenu").removeClass("open");

    },
    _setLevels: function (navLevel) {
      jQuery(navLevel).each(function (i) {
        jQuery(this).attr("data-level", (i + 1));
      });
    }
  }

  new sideMenu("nav.navbar", "#main", ".hamburger");
});
},{}]},{},[1])